import {IPortalState} from 'modules/portal/types';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export const portalModuleName = 'portal';

const initialState: IPortalState = {};

export const portalSlice = createSlice({
    initialState,
    name: portalModuleName,
    reducers: {
        actionPortalHideAll(state: IPortalState) {
            Object.keys(state).forEach((portalName) => (state[portalName].visible = false));
        },

        actionSetPortalHidden(state: IPortalState, {payload}: PayloadAction<string>) {
            state[payload] = {
                visible: false,
            };
        },

        actionSetPortalVisible(state: IPortalState, {payload}: PayloadAction<string>) {
            state[payload] = {
                visible: true,
            };
        },
    },
});

export const {
    actions: {actionSetPortalHidden, actionSetPortalVisible, actionPortalHideAll},
} = portalSlice;

export const {reducer: portalReducer} = portalSlice;
